<div class="relative inline-block" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
  <div (click)="onClick()">
    <ng-content></ng-content>
  </div>

  <!-- Popup -->
  @if (showPopup && group) {
    <div class="absolute top-full left-1/2 mt-2 z-50 opacity-0 animate-fade-in pointer-events-none">
      <div
        class="bg-white rounded-lg shadow-lg border border-slate-200 p-4 w-64 pointer-events-auto"
      >
        <!-- Arrow -->
        <div
          class="absolute -top-1 left-1/2 -translate-x-1/2 w-2 h-2 bg-white border-l border-t border-slate-200 rotate-45"
        ></div>

        <!-- Content -->
        <div class="space-y-2 -mt-1">
          <h3 class="font-bold text-gray-900 text-sm">{{ group.name }}</h3>
          <p class="text-xs text-gray-600 line-clamp-3">
            {{ group.description || 'No description provided' }}
          </p>
        </div>
      </div>
    </div>
  }
</div>
